import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const HeartBeatIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Heart Beat`} {...props}>
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M.75 6.75h3l3-6 2 12 3-6h3"
    />
  </Icon>
);
